/**
 * Form-error paths for sparse configuration patches.
 *
 * Only rendered primitive leaves are Formik fields. Wire identity, schema,
 * and container errors stay out of the known-field set so the form banner
 * surfaces them. Returns plain JavaScript and performs no I/O.
 */

const HIDDEN_WIRE_FIELDS = new Set([
  'editable_fields',
  'input_number',
  'key',
  'schema_version',
  'sensor_number',
  'sensor_type',
]);

function collectRenderedLeafPaths(value, prefix, paths) {
  if (value == null || typeof value !== 'object') {
    if (prefix) paths.push(prefix);
    return;
  }

  Object.entries(value).forEach(([field, child]) => {
    if (HIDDEN_WIRE_FIELDS.has(field)) return;
    const path = prefix ? `${prefix}.${field}` : field;
    collectRenderedLeafPaths(child, path, paths);
  });
}

/**
 * @param {object|null} patch sparse management PATCH
 * @returns {string[]} paths backed by visible Formik controls
 */
export default function buildRenderedPatchKnownFields(patch) {
  const paths = [];
  collectRenderedLeafPaths(patch, '', paths);
  return paths;
}
